/**
 * Shared formatting utilities for display.
 */

export function formatAddressSummary(addr) {
  if (!addr) return '';
  const parts = String(addr)
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean);
  if (!parts.length) return addr;
  return parts.slice(0, 3).join(', ');
}

export function buildGoogleMapsUrl(query) {
  if (!query) return '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

/** Build Google Maps URL for a marker. Prefers address for place matching, else title, else coordinates. */
export function buildGoogleMapsUrlForMarker({ lat, lon, address, title }) {
  const query = address || title || (Number.isFinite(Number(lat)) && Number.isFinite(Number(lon)) ? `${lat},${lon}` : '');
  if (!query) return '';
  return buildGoogleMapsUrl(String(query));
}
